import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
 const LOGIN_SCOPES = [ 'user.read','calendars.readwrite',"mail.send", "mail.send.shared", 'sites.readwrite.all','openid', 'profile', 'mail.readwrite','files.readwrite.all', 'group.readwrite.all','sites.fullcontrol.all' ]

 export const msalConfig = {
    auth: {
        clientId: process.env.VUE_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/"+process.env.VUE_APP_TENNANT_ID.replace(/'/g, "").replace(/"/g, ""),
        redirectUri: process.env.VUE_APP_MS_REDIRECT_URI
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes:LOGIN_SCOPES, 
    prompt: 'login'
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const tokenRequest = {
    scopes: LOGIN_SCOPES,
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};